import { styleHelper } from "../../helpers/commonFunctions";
import { ComboPackageType } from "../../interfaces/comboPackage/ComboPackage.type";
import ComboPackageGroup from "./ComboPackageGroup";
import styles from "./ComboPackageGroupContainer.module.css";
export default function ComboPackageGroupContainer({
  items,
  scroll,
}: {
  items: ComboPackageType[];
  scroll?: Boolean;
}) {
  return (
    <div className={`vas-w-100 vas-py-2`}>
      {scroll ? (
        <div
          className={`${styles.combo_group_card} vas-d-flex vas-gap-3 vas-position-relative vas-pb-3 `}
          style={styleHelper({ overflowX: "auto" })}
        >
          {items?.map((item: ComboPackageType, idx: number) => {
            return <ComboPackageGroup item={item} key={idx} scroll={scroll} />;
          })}
        </div>
      ) :   (
        <div>
           {items?.map((item: ComboPackageType, idx: number) => {
            return <ComboPackageGroup item={item} key={idx} />;
          })}
        </div>
      )}
    </div>
  );
}
